import { filter } from "rxjs/operators";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
  AbstractControl,
  ValidatorFn
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { AppConfig } from "../../../../app.config";
import { MessageService } from "primeng/api";
import { RegistrationService } from "../../../../services/registration.service";
import { AddEditServiceTypeV2Component } from "../../../modals/add-edit-service-type-v2/add-edit-service-type-v2.component";
import { PartnerService } from "../../../../services/partner.service";
import { HelpersService } from "../../../../services/helpers.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-wizard-service-types",
  templateUrl: "./wizard-service-types.component.html",
  styleUrls: ["./wizard-service-types.component.scss"],
  providers: [MessageService]
})
export class WizardServiceTypesComponent implements OnInit {
  @Input() messageService: MessageService;
  @Input() partner;
  @Input() verificationCode;
  @Output() next = new EventEmitter();

  public serviceTypes: any = [];
  public loading = true;
  public category = "";
  public CATEGORIES = [
    {
      name: "General",
      color: "#" + Math.floor(Math.random() * 16777215).toString(16),
      deletable: true
    },
    {
      name: "Suspension",
      color: "#" + Math.floor(Math.random() * 16777215).toString(16),
      deletable: true
    },
    {
      name: "Brakes",
      color: "#" + Math.floor(Math.random() * 16777215).toString(16),
      deletable: true
    },
    {
      name: "Bike Fit",
      color: "#" + Math.floor(Math.random() * 16777215).toString(16),
      deletable: true
    },
    {
      name: "Wheels and Tyres",
      color: "#" + Math.floor(Math.random() * 16777215).toString(16),
      deletable: true
    }
  ];
  public open = "";
  public isPortal = false;

  constructor(
    private registrationService: RegistrationService,
    private partnerService: PartnerService,
    public helpersService: HelpersService,
    public modalService: NgbModal,
    public router: Router
  ) {}

  ngOnInit() {
    this.registrationService
      .verifyAccount(this.verificationCode)
      .subscribe((partnerTmp: any) => {
        //Get Updated  Partner as the modals for Service Type need the currency symbols etc which are missing from the initial partner
        this.partnerService.getPartnerDetail(partnerTmp.PartnerID).subscribe(
          partner => {
            this.partner = partner;
            this.helpersService.savePartnerData(this.partner);
            this.getServiceTypes();
          },
          err => {
            this.loading = false;
          }
        );
      });
  }

  setOpen(category) {
    this.open = this.open === category ? "" : category;
  }

  addCategory() {
    if (this.category !== "") {
      this.CATEGORIES.push({
        name: this.category,
        color: "#" + Math.floor(Math.random() * 16777215).toString(16),
        deletable: true
      });
      this.category = "";
    }
  }

  deleteCategory(category) {
    if (!this.serviceTypes[category]) {
      this.CATEGORIES = this.CATEGORIES.filter(x => x.name !== category);
    } else {
      this.setOpen(category);
    }
  }

  getServiceTypes() {
    this.loading = true;
    this.partnerService
      .getPartnerServiceTypesFull(this.partner.ID)
      .subscribe(serviceTypes => {
        this.loading = false;
        let temp = {};
        serviceTypes.forEach(element => {
          const hoursFloored = Math.floor(element.Hours);
          element.displayTime =
            `${hoursFloored}h` +
            (element.Hours > hoursFloored
              ? ` ${Math.round((element.Hours - hoursFloored) * 60)}min`
              : ``);
          if (temp[element.GroupName]) {
            temp[element.GroupName].push(element);
          } else {
            temp[element.GroupName] = [element];
          }
          if (this.CATEGORIES.find(x => x.name === element.GroupName)) {
            this.CATEGORIES = this.CATEGORIES.map(x => {
              if (x.name === element.GroupName) {
                x.deletable = false;
              }
              return x;
            });
          } else {
            this.CATEGORIES.push({
              name: element.GroupName,
              color: "#" + Math.floor(Math.random() * 16777215).toString(16),
              deletable: false
            });
          }
        });
        this.serviceTypes = temp;
      });
  }

  addServiceType(category) {
    let modalRef;
    modalRef = this.modalService.open(AddEditServiceTypeV2Component, {
      size: "lg",
      backdrop: "static",
      windowClass: "dark-mode"
    });
    modalRef.componentInstance.partnerId = this.partner.ID;
    modalRef.componentInstance.messageService = this.messageService;
    modalRef.componentInstance.GroupName = category;
    modalRef.result.then(
      result => {
        this.CATEGORIES = this.CATEGORIES.map(x => {
          if (x.name === category) {
            x.deletable = false;
          }
          return x;
        });
        this.getServiceTypes();
      },
      onrejected => {
        this.getServiceTypes();
      }
    );
  }

  skipToHubtiger() {
    this.router.navigateByUrl("/store/dashboard");
  }
}
